module.exports = __webpack_public_path__ + "static/151812309.fbff0233.jpg";